<template>
    <section class="mt-2 mb-3 mb-lg-4" id="paso-2">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="text-uppercase mb-5">{{ $t('bases.datos_responsables') }}</h2>
                    <div class="mb-2">
                        <div class="mb-4 h4 text-uppercase">
                            {{ $t('bases.datos_responsable_1') }}
                        </div>
                        <ValidationObserver tag="form" ref="observerResponsables" @submit.prevent="submit()">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.nombre_responsable_1"
                                        id="nombre_responsable_1"
                                        name="nombre_responsable_1"
                                        rules="required"
                                        :disabled="loading"
                                        :label="$t('formularios.nombre_responsable_1')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.apellidos_responsable_1"
                                        id="apellidos_responsable_1"
                                        name="apellidos_responsable_1"
                                        rules="required"
                                        :disabled="loading"
                                        :label="$t('formularios.apellidos_responsable_1')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <DocumentoTipo
                                        id="tipo_documento_responsable_1"
                                        :value="localData.tipoDocumentoSeleccionadoResponsable1"
                                        :index="1"
                                        :disabled="loading"
                                        @input="val => { $set(localData, 'tipoDocumentoSeleccionadoResponsable1', val); localData.dni_responsable_1 = ''; }"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <DocumentoValor
                                        :type="localData.tipoDocumentoSeleccionadoResponsable1"
                                        :value="localData.dni_responsable_1"
                                        :index="1"
                                        :disabled="loading"
                                        @input="val => { localData.dni_responsable_1 = val; }"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('formularios.telefono_responsable_1') }}</label>
                                        <PhoneInput
                                            dataCy="telefono_responsable_1"
                                            :phone="localData.telefono_responsable_1 ?? null"
                                            :desactivar="loading"
                                            :forceValidate="forcePhoneValidationResponsable1"
                                            @setNumber="(number) => localData.telefono_responsable_1 = number"
                                            @validNumber="(valid) => isValidNumberResponsable1 = valid"
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.email_responsable_1"
                                        id="email_responsable_1"
                                        name="email_responsable_1"
                                        rules="required|email"
                                        :disabled="loading"
                                        :label="$t('formularios.email_responsable_1')"
                                    />
                                </div>
                                <template v-if="fields && fields.length > 0">
                                    <div v-for="(field, index) in fields" :key="field.type + '_responsable_1_' + index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')">
                                        <FieldComponent
                                            :field="field"
                                            :desactivar="loading"
                                            entradaIndex="responsable_1"
                                            :fieldIndex="index"
                                            v-model="localData.fields_responsable_1[field.name]"
                                        />
                                    </div>
                                </template>
                                <div class="col-12">
                                    <hr />
                                </div>
                                <div class="col-12 mt-2">
                                    <div class="mb-4 h4 text-uppercase">
                                        {{ $t('bases.datos_responsable_2') }}
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.nombre_responsable_2"
                                        id="nombre_responsable_2"
                                        name="nombre_responsable_2"
                                        :rules="responsable2Required ? 'required' : ''"
                                        :disabled="loading"
                                        :label="$t('formularios.nombre_responsable_2')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.apellidos_responsable_2"
                                        id="apellidos_responsable_2"
                                        name="apellidos_responsable_2"
                                        :rules="responsable2Required ? 'required' : ''"
                                        :disabled="loading"
                                        :label="$t('formularios.apellidos_responsable_2')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <DocumentoTipo
                                        id="tipo_documento_responsable_2"
                                        :value="localData.tipoDocumentoSeleccionadoResponsable2"
                                        :index="2"
                                        :disabled="loading"
                                        @input="val => { $set(localData, 'tipoDocumentoSeleccionadoResponsable2', val); localData.dni_responsable_2 = ''; }"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <DocumentoValor
                                        :type="localData.tipoDocumentoSeleccionadoResponsable2"
                                        :value="localData.dni_responsable_2"
                                        :index="2"
                                        :disabled="loading"
                                        :required="responsable2Required"
                                        @input="val => { localData.dni_responsable_2 = val; }"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('formularios.telefono_responsable_2') }}</label>
                                        <PhoneInput
                                            dataCy="telefono_responsable_2"
                                            :phone="localData.telefono_responsable_2 ?? null"
                                            :desactivar="loading"
                                            :forceValidate="forcePhoneValidationResponsable2"
                                            @setNumber="(number) => localData.telefono_responsable_2 = number"
                                            @validNumber="(valid) => isValidNumberResponsable2 = valid"
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.email_responsable_2"
                                        id="email_responsable_2"
                                        name="email_responsable_2"
                                        :rules="responsable2Required ? 'required|email' : 'email'"
                                        :disabled="loading"
                                        :label="$t('formularios.email_responsable_2')"
                                    />
                                </div>
                                <template v-if="fields && fields.length > 0">
                                    <div v-for="(field, index) in fields" :key="field.type + '_responsable_2_' + index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')">
                                        <FieldComponent
                                            :field="field"
                                            :desactivar="loading"
                                            entradaIndex="responsable_2"
                                            :fieldIndex="index"
                                            v-model="localData.fields_responsable_2[field.name]"
                                        />
                                    </div>
                                </template>
                                <br />
                                <div class="col-12">
                                    <FormInput
                                        v-model="localData.observaciones"
                                        id="observaciones"
                                        name="observaciones"
                                        type="textarea"
                                        :disabled="loading"
                                        :label="$t('formularios.observaciones')"
                                    />
                                </div>
                            </div>
                            <div class="text-right mt-3">
                                <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1" :disabled="loading" >
                                    <span>{{ $t('formularios.atras') }}</span>
                                </button>
                                <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" data-cy="terminar-paso-2" id="terminar-paso-2" :disabled="loading">
                                    <span>{{ $t('formularios.continuar') }}</span>
                                </button>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import FieldComponent from '@/components/common/FieldComponent.vue';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo';
    import DocumentoValor from '@/components/common/DocumentoValor';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            fields: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                localData: { ...this.base },
                isValidNumberResponsable1: false,
                isValidNumberResponsable2: false,
                forcePhoneValidationResponsable1: false,
                forcePhoneValidationResponsable2: false,
                responsable2Required: false,
                loading: false
            };
        },
        methods: {
            terminar() {
                this.loading = true;

                const responsable1 = {
                    nombre: this.localData.nombre_responsable_1,
                    apellidos: this.localData.apellidos_responsable_1,
                    dni: this.localData.dni_responsable_1,
                    telefono: this.localData.telefono_responsable_1,
                    email: this.localData.email_responsable_1,
                    fields: this.localData.fields_responsable_1
                };

                const responsable2 = {
                    nombre: this.localData.nombre_responsable_2,
                    apellidos: this.localData.apellidos_responsable_2,
                    dni: this.localData.dni_responsable_2,
                    telefono: this.localData.telefono_responsable_2,
                    email: this.localData.email_responsable_2,
                    fields: this.localData.fields_responsable_2
                };

                const params = {
                    session_id: this.localData.session_id,
                    responsable_1: responsable1,
                    filters: {}
                };

                if (this.hayResponsable2) {
                    params.responsable_2 = responsable2;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-responsables'), params).then(() => {
                    this.$emit('terminado', this.localData);
                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    this.loading = false;
                });
            },
            volver() {
                this.$emit('volver')
            },
            async submit() {
                this.forcePhoneValidationResponsable1 = !this.localData.telefono_responsable_1;

                if (this.hayResponsable2) {
                    this.forcePhoneValidationResponsable2 = !this.localData.telefono_responsable_2;
                    this.responsable2Required = !this.localData.telefono_responsable_2;
                } else {
                    this.forcePhoneValidationResponsable2 = false;
                    this.responsable2Required = false;
                }

                await this.$nextTick();

                const isValid = await this.$refs.observerResponsables.validate();

                const telefonosValidos =
                    !this.forcePhoneValidationResponsable1 &&
                    !this.forcePhoneValidationResponsable2 &&
                    this.isValidNumberResponsable1 &&
                    (this.hayResponsable2 ? this.isValidNumberResponsable2 : true);

                if (isValid && telefonosValidos) {
                    this.terminar();
                }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            hayResponsable2() {
                const baseFields =
                    this.localData?.nombre_responsable_2 ||
                    this.localData?.apellidos_responsable_2 ||
                    this.localData?.dni_responsable_2 ||
                    this.localData?.email_responsable_2 ||
                    this.localData?.telefono_responsable_2;

                const extraFields = this.localData?.fields_responsable_2
                    ? Object.values(this.localData.fields_responsable_2).some(
                        val => val !== null && val !== undefined && val !== ''
                    )
                    : false;

                return baseFields || extraFields;
            }
        },
        watch: {
            hayResponsable2(nuevoValor) {
                if (nuevoValor && !this.localData.tipoDocumentoSeleccionadoResponsable2) {
                    this.$set(this.localData, 'tipoDocumentoSeleccionadoResponsable2', this.localData.tipoDocumentoSeleccionadoResponsable1);
                }

                if (!nuevoValor) {
                    this.$set(this.localData, 'tipoDocumentoSeleccionadoResponsable2', null);
                    this.forcePhoneValidationResponsable2 = false;
                }
            }
        },
        created() {
            if (!this.localData.tipoDocumentoSeleccionadoResponsable1) {
                this.$set(this.localData, 'tipoDocumentoSeleccionadoResponsable1', 'DNI');
            }

            if (!this.localData.fields_responsable_1) {
                this.$set(this.localData, 'fields_responsable_1', {});
            }
            if (!this.localData.fields_responsable_2) {
                this.$set(this.localData, 'fields_responsable_2', {});
            }
        },
        components: {
            FieldComponent,
            PhoneInput,
            DocumentoTipo,
            DocumentoValor
        }
    };
</script>
